import { Component } from '@angular/core';

@Component({
  selector: 'app-dialog-footer',
  standalone: true,
  host: {
    class: 'flex flex-col-reverse gap-2 px-6 pb-6 pt-2 sm:flex-row sm:justify-end sm:items-center',
  },
  template: `<ng-content />`,
})
export class DialogFooterComponent {}
